import { push } from 'connected-react-router'
import { getTeamUrl } from 'Common'

export default (id) => (dispatch) => {

  dispatch(push(getTeamUrl(`sub_projects/${id}`)))

}
